let Slider;

function startSlider() {
  if (window.innerWidth <= 768) {
    Slider = new window.Swiper('.swiper-mobile', {
      slidesPerView: 1.33,
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
    });
  } else {
    Slider = new window.Swiper('.swiper-desktop', {
      slidesPerView: 2.5,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        900: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 'auto',
        }
      }
    });
  }
 
}

document.addEventListener('DOMContentLoaded', ()=> {
  startSlider()
})

